export enum UploadError {
  NONE,
  CSV_WRONG_EXTENSION_FILE,
  CSV_MISSING_HEADER,
  CSV_INCORRECT_FORMAT,
}
